<template>
  <div>
    <h3 class="mb-5">Departments & Teams</h3>
    <div class="h4 mb-5">
      編輯Department 於Career Page的封面圖文及Department Introduction Page內頁
    </div>
    <!-- Items -->
    <div>
      <div
        class="form-item-last-no-border d-flex py-3 align-center"
        v-for="(item, i) in career.teams"
        :key="i"
      >
        <div
          class="w-40px h-40px bg-cover bg-center bg-c"
          :style="{
            'background-image': `url(${item.visual})`,
          }"
        ></div>
        <div class="h4 ml-5">{{ item.title }}</div>
        <div class="ml-auto">
          <!--<button-->
            <!--class="btn square ml-10px "-->
            <!--@click="item.isStar = !item.isStar"-->
          <!--&gt;-->
            <!--<v-icon v-if="item.isStar" class="warning-500&#45;&#45;text">star</v-icon>-->
            <!--<v-icon v-else>star_border</v-icon>-->
          <!--</button>-->
          <button class="btn square ml-10px" @click="editItem(item)">
            <v-icon>edit</v-icon>
          </button>
          <button class="btn square ml-10px" @click="deleteItem(item)">
            <v-icon>delete</v-icon>
          </button>
          <button class="btn square ml-10px" @click="downItem(item, i)">
            <v-icon>arrow_downward</v-icon>
          </button>
          <button class="btn square ml-10px" @click="upItem(item, i)">
            <v-icon>arrow_upward</v-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- add item -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem()">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加Department</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    career: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    ...mapActions({
      initTeamDetail: 'career/initTeamDetail',
    }),
    addItem() {
      const detail = {
        title: '',
        visual: '',
        introduction: '',
        introduction_title: '',
        introduction_banner: '',
        content: [],
      };
      this.initTeamDetail(detail);
      this.$router.push({ path: '/career-page/edit/department-detail-edit' });
    },
    editItem(detail) {
      this.initTeamDetail(detail);
      this.$router.push({ path: '/career-page/edit/department-detail-edit' });
    },
    deleteItem(item) {
      const index = this.career.teams.map((option) => option.id).indexOf(item.id);
      this.career.teams.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.career.teams.length - 1) {
        this.career.teams.splice(i, 1);
        this.career.teams.unshift(item);
        return;
      }
      // item become next index
      this.career.teams.splice(i, 1);
      this.career.teams.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.career.teams.splice(i, 1);
        this.career.teams.push(item);
        return;
      }
      // item become previous index
      this.career.teams.splice(i, 1);
      this.career.teams.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
